// @flow

import mapKeys from "lodash/mapKeys";
import snakeCase from "lodash/snakeCase";
import { type FormApi } from "final-form";

export const generateInitialValues = (obj: Object) => mapKeys(obj, (val, key) => snakeCase(key));

/**
 * Returns whether the form is being submitted, if form is invalid returns null
 * @param {FormApi} form final-form's FormApi object
 * @returns {?boolean} the value of FormState.submitting, if invalid – null
 */
export const isFormSubmitting = (form: FormApi) => {
  if (!form.getState) {
    return null;
  }

  const state = form.getState();
  if (!state) {
    return null;
  }

  return state.submitting;
};
